import { defineComponent, ref, onMounted, onUpdated } from 'vue';
import { props } from './props';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = n => (_pushScopeId(""), n = n(), _popScopeId(), n);

var _hoisted_1 = {
  class: "var-app-bar__left"
};
var _hoisted_2 = {
  key: 0,
  class: "var-app-bar__title"
};
var _hoisted_3 = {
  class: "var-app-bar__right"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["var-app-bar", {
      'var-elevation--3': _ctx.elevation
    }]),
    style: _normalizeStyle({
      background: _ctx.color,
      color: _ctx.textColor
    })
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "left"), _ctx.titlePosition === 'left' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "var-app-bar__title",
    style: _normalizeStyle({
      paddingLeft: _ctx.paddingLeft
    })
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(_ctx.title), 1
  /* TEXT */
  )])], 4
  /* STYLE */
  )) : _createCommentVNode("v-if", true)]), _ctx.titlePosition === 'center' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(_ctx.title), 1
  /* TEXT */
  )])])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_3, [_ctx.titlePosition === 'right' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "var-app-bar__title",
    style: _normalizeStyle({
      paddingRight: _ctx.paddingRight
    })
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(_ctx.title), 1
  /* TEXT */
  )])], 4
  /* STYLE */
  )) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "right")])], 6
  /* CLASS, STYLE */
  );
}
export default defineComponent({
  render,
  name: 'VarAppBar',
  props,

  setup(props, _ref) {
    var {
      slots
    } = _ref;
    var paddingLeft = ref();
    var paddingRight = ref();

    var computePadding = () => {
      paddingLeft.value = slots.left ? 0 : undefined;
      paddingRight.value = slots.right ? 0 : undefined;
    };

    onMounted(computePadding);
    onUpdated(computePadding);
    return {
      paddingLeft,
      paddingRight
    };
  }

});